<!--
    描述：主体列表
    日期：2021/06/07
    作者：zwh
-->
<template>
	<div class="h100">
		<div class="w-table-layout">
			<div class="w-table-content"
				 ref="tableContent">
				<el-table :data="tableObj.data"
						  row-key="id"
						  v-loading="tableObj.loading"
						  ref="tenantTree"
						  :height="tableObj.tableH"
						  border
						  highlight-current-row
						  default-expand-all
						  @row-click="rowClick"
						  :tree-props="{children: 'children'}">
					<el-table-column prop="sname"
									 label="名称"
									 align="center"
									 show-overflow-tooltip
									 min-width="150">
						<template slot="header"
								  slot-scope="scope">
							<div>主体名称
								<el-tooltip effect="light">
									<div slot="content">
										主体管理功能用途说明：</br>
										1.维护项目管理系统内相关主体类型</br>
										2.配置每个主体类型的最大菜单权限范围
									</div>
									<i class="el-icon-question"></i>
								</el-tooltip>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作"
									 header-align="center"
									 align="center"
									 show-overflow-tooltip
									 min-width="100">
						<template slot-scope="scope">
							<el-button size="mini"
									   icon="el-icon-edit"
									   title="编辑"
									   type="text"
									   v-if="roleBtns.includes('limit_menu_range_limit_edit')"
									   @click="doClick('edit', scope.row)"></el-button>
							<el-button size="mini"
									   icon="el-icon-delete"
									   title="删除"
									   type="text"
									   v-if="roleBtns.includes('limit_menu_range_limit_delete')"
									   @click="doClick('delete', scope.row)"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 弹窗组件 -->
			<div v-if="dialogObj.visible">
				<el-form :model="objectForm"
						 :rules="formRules"
						 ref="objectForm"
						 size="mini"
						 label-width="80px">
					<el-row>
						<el-col>
							<el-form-item label="主体名称"
										  prop="sname"
										  :show-message="false">
								<el-input v-model="objectForm.sname"
										  autocomplete="off"
										  :show-message="false"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col>
							<el-form-item label="备注"
										  prop=""
										  :show-message="false">
								<el-input v-model="objectForm.remark"
										  type="textarea"
										  autocomplete="off"
										  :maxlength="500"
										  show-word-limit></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="logo"
								  prop=""
								  :show-message="false">
						<myUpload :acceptType="acceptType"></myUpload>
					</el-form-item>
				</el-form>
			</div>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	selectAll,
	saveOrUpdateRange,
	deleteByIdRange,
	getObjectById,
} from 'api/system/roleLimit.js'
export default {
	name: '',
	components: {},
	data() {
		return {
			btnLoading: false,
			tableObj: {
				loading: false,
				tableH: 200,
				data: [],
				expandKeys: [],
			},

			dialogObj: {
				title: '',
				visible: false,
				width: '500px',
				mode: 'add',
			},

			objectForm: {
				id: '',
				sname: '',
				remark: '',
			},
			formRules: {
				sname: [
					{ required: true, message: '请输入...', trigger: 'blur' },
				],
			},
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	// 进入页面缓存
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.tableContent.offsetHeight
			}, 100)
		})
	},
	created() {
		this.getLimitTable()
	},
	methods: {
		getLimitTable() {
			let that = this
			selectAll({}).then((res) => {
				if (res.operationCode == 1) {
					that.tableObj.data = res.data.limits

					if (res.data.limits.length > 0) {
						this.rowClick(res.data.limits[0])
						this.$refs.tenantTree.setCurrentRow(res.data.limits[0])
					}
				}
			})
		},
		doClick(type, row) {
			if (type == 'add') {
				this.resetForm()
				this.dialogObj.title = '主体新增'
				this.dialogObj.visible = true
			} else if (type == 'edit') {
				this.resetForm()
				this.dialogObj.title = '主体修改'
				this.dialogObj.visible = true
				this.getObjectById(row)
			} else if (type == 'delete') {
				this.deleteByIdRange(row)
			}
		},
		rowClick(e) {
			this.$emit('row-click', e)
		},
		// 确定按钮事件
		doSave() {
			let that = this
			this.$refs['objectForm'].validate((valid) => {
				if (valid) {
					let param = this.objectForm
					saveOrUpdateRange(param).then((res) => {
						if (res.operationCode == 1) {
							that.$message({
								message: '保存成功',
								type: 'success',
							})
							that.dialogObj.visible = false
							that.getLimitTable()
							this.$emit('row-click', '')
						} else if (res.operationCode == 0) {
							this.$message.error(res.data)
						} else {
							this.$message.error('保存失败')
						}
					})
				}
			})
		},
		getObjectById(row) {
			let that = this
			let param = {
				id: row.id,
			}
			getObjectById(param).then((res) => {
				if (res.operationCode == 1) {
					that.objectForm.id = res.data.id
					that.objectForm.sname = res.data.sname
					that.objectForm.remark = res.data.remark
				} else {
					that.$message.error('获取信息失败')
				}
			})
		},
		deleteByIdRange(row) {
			this.$confirm('确认删除该用户', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				let param = {}
				param.id = row.id
				deleteByIdRange(param).then((res) => {
					if (res.operationCode == 1) {
						this.$message.success('删除成功！')
						this.getLimitTable()
						this.$emit('row-click', '')
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		// 关闭弹窗事件
		handleClose() {},
		resetForm() {
			let that = this
			Object.keys(that.objectForm).forEach(
				(key) => (that.objectForm[key] = '')
			)
		},
	},
	computed: {
		// 是否可编辑
		isDisabled() {
			return this.mode === 'view' ? true : false
		},
		...mapState('app', { clientSize: (state) => state.clientSize }),
		// ...mapState('dict', {
		// 	dwlx: state => state.dwlx
		// }),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		// logo 支持格式
		acceptType() {
			return ['jpg', 'jpeg', 'gif', 'png', 'bmp']
		},
	},
	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.tableContent.offsetHeight
		},
	},
}
</script>
<style lang="less">
</style>